import { render, staticRenderFns } from "./DialogVX.vue?vue&type=template&id=6abbeedb"
import script from "./DialogVX.vue?vue&type=script&lang=js"
export * from "./DialogVX.vue?vue&type=script&lang=js"
import style0 from "./DialogVX.vue?vue&type=style&index=0&id=6abbeedb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports